import React, { useEffect } from 'react';
import { MainContainer } from '../../../common/CardBoardStyled';
import constants from '../../../../../core/constants';
import Frame from '../../../../components/Frame';
import useProfile from '../../../../hooks/useProfile';
import { ButtonBack } from '../../../procedures/modules/certificates-constancies/type1/info/components';

interface BalanceProps {
  goBackButton: () => void;
}

const PaymentsBalanceView = (props: BalanceProps) => {
  const { goBackButton } = props;
  const { profile, academic } = useProfile();

  useEffect(() => {
    document.title = `UTP + Portal | Pagos`;
    return () => {
      document.title = `UTP+ Portal | Universidad Tecnológica del Perú`;
    };
  }, []);

  return (
    <MainContainer
      className="containerProcedureB"
      data-testid="cmp-payment-balance-view"
    >
      <div style={{ margin: '0 auto', maxWidth: '1128px', width: '100%' }}>
        <ButtonBack onClick={goBackButton} />
      </div>
      <div className="fixedWidth">
        <Frame
          source={`${constants.PE_URL}${constants.PE_PATH_PAYMENTS}`}
          title="Portal del Estudiante"
        >
          <input type="hidden" name="emplid" value={profile.peopleCode} />
          <input type="hidden" name="grado" value={academic.career} />
          <input type="hidden" name="campus" value={academic.campus} />
        </Frame>
      </div>
    </MainContainer>
  );
};

export default PaymentsBalanceView;
